export { default as SearchInput } from './search-input';
export type { SearchInputProps } from './types';
